export enum CustomPosthogEvent {
  DATA_OWNER_ASSIGNED = 'data-owner-assigned',
  MATERIALITY_IDENTIFICATION_REQUEST_SENT = 'materiality-identification-request-sent',
  MATERIALITY_EVALUATION_REQUEST_SENT = 'materiality-evaluation-request-sent',
  STAKEHOLDER_GROUP_UPDATED = 'stakeholder-group-updated',
  REPORT_SECTION_MARKED_COMPLETED = 'report-section-marked-completed',
  REPORT_SECTION_TEXT_UPDATED = 'report-section-text-updated',
  REPORT_CREATED = 'report-created',
  REPORT_DOWNLOADED = 'report-downloaded',
  UPDATE_DATA_POINTS_VALUE = 'update-data-points-value',
  CREATE_PRE_DEFINED_IRO = 'create-pre-defined-iro',
  CREATE_NEW_GOAL = 'create-new-goal',
  CREATE_NEW_ACTION = 'create-new-action',
  ESCALATE_TO_SUPPORT_CLICKED = 'escalate-to-support-clicked',
  CHAT_ACTION = 'chat-action',
}
